import {useEffect, useState} from "react";
import {motion, useSpring} from "framer-motion";

const ROTATION_INTERVAL_MS = 4000;
const FADE_OUT_DURATION_MS = 500;

export const useAnimatedHomepageHeader = (slides: string[], className?: string) => {
    const [index, setIndex] = useState(0);

    const opacity = useSpring(1, {stiffness: 100, damping: 20});

    useEffect(() => {
        opacity.set(1);

        if (slides.length < 2) {
            return;
        }

        const fadeOutTimeout = setTimeout(() => opacity.set(0), ROTATION_INTERVAL_MS - FADE_OUT_DURATION_MS);
        const rotationTimeout = setTimeout(() => setIndex((state) => (state + 1) % slides.length), ROTATION_INTERVAL_MS);

        return () => {
            clearTimeout(fadeOutTimeout);
            clearTimeout(rotationTimeout);
        };
    }, [index, slides.length, opacity]);

    return (
        <motion.span className={className} style={{opacity}}>
            {slides[index]}
        </motion.span>
    );
};
import {useEffect, useState} from "react";
import {motion, useSpring} from "framer-motion";

const ROTATION_INTERVAL_MS = 4000;
const FADE_OUT_DURATION_MS = 500;

export const useAnimatedHomepageHeader = (slides: string[], className?: string) => {
    const [index, setIndex] = useState(0);

    const opacity = useSpring(1, {stiffness: 100, damping: 20});

    useEffect(() => {
        opacity.set(1);

        if (slides.length < 2) {
            return;
        }

        const fadeOutTimeout = setTimeout(() => opacity.set(0), ROTATION_INTERVAL_MS - FADE_OUT_DURATION_MS);
        const rotationTimeout = setTimeout(() => setIndex((state) => (state + 1) % slides.length), ROTATION_INTERVAL_MS);

        return () => {
            clearTimeout(fadeOutTimeout);
            clearTimeout(rotationTimeout);
        };
    }, [index, slides.length, opacity]);

    return (
        <motion.span className={className} style={{opacity}}>
            {slides[index]}
        </motion.span>
    );
};
